import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLightningBolt = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M26.3734 2C27.7128 2 28.6997 3.33594 28.3473 4.60156L24.5405 17.75H30.6031C31.9426 17.75 33 18.875 33 20.2109C33 20.9844 32.718 21.6172 32.154 22.1094L13.8956 37.5781C13.5431 37.8594 13.1201 38 12.6266 38C11.2872 38 10.3003 36.7344 10.6527 35.4688L14.4595 22.25H8.32637C7.05744 22.25 6 21.1953 6 19.9297C6 19.2266 6.28198 18.5938 6.77546 18.1016L25.1044 2.49219C25.4569 2.21094 25.8799 2 26.3734 2ZM23.8355 7.97656L11.0757 18.875H16.7154C17.2089 18.875 17.7024 19.1562 18.0548 19.5781C18.3368 20 18.4778 20.5625 18.3368 21.0547L15.1645 32.0938L28.0653 21.125H22.3551C21.7911 21.125 21.2977 20.9141 20.9452 20.4922C20.6632 20.0703 20.5222 19.5078 20.6632 19.0156L23.8355 7.97656Z" })
});
export default SvgLightningBolt;
